import { render, staticRenderFns } from "./Transactionality.vue?vue&type=template&id=67131301&scoped=true&"
import script from "./Transactionality.vue?vue&type=script&lang=ts&"
export * from "./Transactionality.vue?vue&type=script&lang=ts&"
import style0 from "./Transactionality.vue?vue&type=style&index=0&id=67131301&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67131301",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRadio,VRadioGroup,VRow,VTextField,VTooltip})
